<header>
  <div class="logo-wrap">
      <button *ngIf="showBackButton" (click)="goBack()" class="material-icons unstyle-button" [attr.aria-label]="commonConstants?.goBack">chevron_left</button>
      <img alt="" src="./../../../assets/logo.svg" />
  </div>
  <div *ngIf="showFlightTicketDetails && travelerDetails?.givenName && flightTicketDetails?.confirmationID" class="flight-ticket-details">
    <div class='passenger-details'>
      <div class="name">Hi, {{travelerDetails.givenName | titlecase}}</div>
      <div class="mileage-plus" *ngIf="travelerDetails?.mpNumber">
          <span class="badge-wrap">
            <img src='{{ "../../../assets/badges/"+ travelerDetails.mpType?.toLowerCase() +".svg" }}' alt="mileage plus" onerror= "this.src = '../../../assets/badges/mp.svg'"/>
          </span>
        <span class="mp-number">{{travelerDetails.mpNumber}}</span>
      </div>
    </div>
    <div class="pnr-number">{{flightTicketDetails.confirmationID}}</div>
  </div>
  <div>
    <!-- -------------- START :: Language selector and Language model----------- -->
  <div class="language-options-wrapper" [class.none]= "hideLang" (click) = "openLangModel()" #langIcon>
    <div class="content">
      <button class="icon-wrap unstyle-button" [attr.aria-label]="commonConstants?.selectLanguage">
        <img src="../../../assets/flag.svg" alt="globe" />
      </button>
    </div>
  </div>
  <div class="language-select" [class.none]= "hideLang">
    <ua-language-select 
      (languageSelect)="selectedLanguage($event)" 
      (dismiss)='closeLangModal()'
      [showModal]="isLangModalOpen" 
      [offset]="langIcon">
    </ua-language-select>
  </div>
  <!-- -------------- END :: Language selector and Language model----------- -->
  </div>
</header>
